<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<p class="toc-fm"><a href="#/008_Foreword#fm-1"><em class="italic">Foreword</em> by Cornelius Plantinga</a></p>
<p class="toc-fm"><a href="#/009_Acknowledgments#fm-2"><em class="italic">Acknowledgments</em></a></p>
<p class="toc-fm1"><a href="#/010_Introduction#fm-3">Introduction: Baptismal Confidence</a></p>
<p class="toc-part"><a href="#/011_Part01#pt-1">Part One: Baptismal Identity</a></p>
<p class="toc-chap"><a href="#/012_Chapter01#ch-1">1. <span class="pad0">The Script</span></a></p>
<p class="toc-chap"><span href="#/013_Chapter02#ch-2" title="Link target outside of Sample">2. <span class="pad0">Kiddie-Pool Piety</span></span></p>
<p class="toc-chap"><span href="#/014_Chapter03#ch-3" title="Link target outside of Sample">3. <span class="pad0">Drowning in a Coffin</span></span></p>
<p class="toc-part"><span href="#/015_Part02#pt-2" title="Link target outside of Sample">Part Two: Baptismal Liturgy for Life</span></p>
<p class="toc-chap"><span href="#/016_Chapter04#ch-4" title="Link target outside of Sample">4. <span class="pad0">Renouncing Evil</span></span></p>
<p class="toc-chap"><span href="#/017_Chapter05#ch-5" title="Link target outside of Sample">5. <span class="pad0">An Ordained Life</span></span></p>
<p class="toc-chap"><span href="#/018_Chapter06#ch-6" title="Link target outside of Sample">6. <span class="pad0">Baptismal Clothes</span></span></p>
<p class="toc-part"><span href="#/019_Part03#pt-3" title="Link target outside of Sample">Part Three: Baptismal Abuse</span></p>
<p class="toc-chap"><span href="#/020_Chapter07#ch-7" title="Link target outside of Sample">7. <span class="pad0">Identity Politics</span></span></p>
<p class="toc-chap"><span href="#/021_Chapter08#ch-8" title="Link target outside of Sample">8. <span class="pad0">Forced Baptism</span></span></p>
<p class="toc-chap"><span href="#/022_Chapter09#ch-9" title="Link target outside of Sample">9. <span class="pad0">Widow Waters</span></span></p>
<p class="toc-chap1"><span href="#/023_Chapter10#ch-10" title="Link target outside of Sample">10. <span class="pad1">Race</span></span></p>
<p class="toc-part"><span href="#/024_Part04#pt-4" title="Link target outside of Sample">Part Four: Baptismal Hope</span></p>
<p class="toc-chap1"><span href="#/025_Chapter11#ch-11" title="Link target outside of Sample">11. <span class="pad1">Healing Waters</span></span></p>
<p class="toc-chap1"><span href="#/026_Chapter12#ch-12" title="Link target outside of Sample">12. <span class="pad1">One Baptism</span></span></p>
<p class="toc-bm1"><span href="#/027_Epilogue#bm-1" title="Link target outside of Sample">Epilogue: A Baptized Imagination</span></p>
<p class="toc-bm"><span href="#/028_Bibliography#bm-2" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Contents.vue?2e4bd25e